import { render, staticRenderFns } from "./approval-travel-index.vue?vue&type=template&id=7d2afa52&scoped=true"
import script from "./approval-travel-index.vue?vue&type=script&lang=js"
export * from "./approval-travel-index.vue?vue&type=script&lang=js"
import style0 from "./approval-travel-index.vue?vue&type=style&index=0&id=7d2afa52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2afa52",
  null
  
)

export default component.exports